import { Content, H1, H2 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import Wave from 'static/svg/wave.svg'

const Container = styled.div`
  flex: 1 1 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  background-size: cover !important;
  ${mq.below('sm')} {
    background-size: cover !important;
  }
`

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  min-height: 600px;
  margin: 0;
  padding: 0 60px;
  ${mq.below('lg')} {
    min-height: 400px;
  }
`

const Title = styled(H1)`
  font-size: 60px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 800;
  line-height: 1.2;
  white-space: break-spaces;
  width: 100%;
  ${mq.below('xl')} {
    font-size: 42px;
  }
`

const StyledWave = styled(Wave)`
  position: absolute;
  left: auto;
  right: auto;
  bottom: 0;
`

const BlogHeader = (props) => {
  const nextType = props?.list?.[1]?.__typename

  const backgroundColor = do {
    if (nextType === 'WordPressAcf_all_subitems') '#FFFFFF'
    else if (nextType === 'WordPressAcf_raw_html') '#FFFFFF'
    else '#E9EAEE'
  }

  return (
    <Container
      style={{
        background: `url(${props?.data?.image?.imgixImageWp?.imageUrl}) no-repeat top center`,
      }}
    >
      <Overlay>
        <StyledContent>
          <Content>
            <Title>{props.data.title}</Title>

            {props.data.text && (
              <Text
                dangerouslySetInnerHTML={{
                  __html: props.data.text,
                }}
              ></Text>
            )}
          </Content>
        </StyledContent>
        <StyledWave fill={backgroundColor} />
      </Overlay>
    </Container>
  )
}

export default BlogHeader
